import * as companyManagementService from "../../services/company";
import * as saleService from "../../services/sales";
import * as settings from "../../services/settings";

import { ArrowLeftOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
  notification,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { usePermission, useUser } from "../../hooks/usePermission"; // 👈 เพิ่ม Hook นี้

import AuthGroup from "../../../configs/authgroup"; // นำเข้า permission จากไฟล์ mapping
import { ModalDelete } from "../../Components/model/modal/delete";
import { ModelCreateSales } from "../../Components/company/modal/modalCreateSales";
import dayjs from "dayjs";
import permissions from "../../../configs/permission";
import { useAccessToken } from "../../contexts/AccessTokenContext";
import { useTranslation } from "react-i18next";

let promiseAwait;
const initPage = { page: 1, limit: 10 };
export const SalesPage = () => {
  const { accessToken } = useAccessToken();
  const { t } = useTranslation("company", "buttons");
  const { t: tSales } = useTranslation("sales");
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const { Title, Link } = Typography;
  const [search, setSearch] = useState(initPage);
  const [selectRowKey, setSelectRowKey] = useState([]);
  const [selectRowValue, setSelectRowValue] = useState([]);
  const [total, setTotal] = useState(0);
  const [countSelect, setCountSelect] = useState(0);
  const [dataList, setDataList] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const { companyId, saleId } = useUser();
  const { hasPermission, isSuperuser, hasGroup } = usePermission();
  const [isDisableSelectCompany, setIsDisableSelectCompany] = useState(false);
  const [isModelOpen, setIsOpenModal] = useState(false);
  const [isEditSale, setIsEditSale] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});
  const [editCompanySalesData, setEditCompanySalesData] = useState([]);
  const [tempSearch, setTempSearch] = useState();
  const [companyList, setCompanyList] = useState([]);

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
      duration: 5,
    });
  };

  const onSelectAll = () => {
    setCountSelect(total);
    setSelectRowKey([]);
    setSelectRowValue([]);
  };

  const rowSelection = {
    selectRowKey,
    onChange: (selectedRowKeys, value) => {
      setSelectRowKey(selectedRowKeys);
      setSelectRowValue(value);
      setCountSelect(value.length);
    },
  };
  const items = [
    {
      title: t("Page_Body_Tab_Menu.Home", { ns: "menus" }),
    },
    {
      title: t("Page_Body_Tab_Menu.Menu", { ns: "menus" }),
    },
    {
      title: (
        <a href="/sales" style={{ fontWeight: 600, color: "black" }}>
          {tSales("Title_Sales")}
        </a>
      ),
    },
  ];

  const columns = [
    {
      title: tSales("Table_Sales.Company_Code"),
      dataIndex: "sale_code",
      key: "sale_code",
    },
    {
      title: tSales("Table_Sales.Sales_Name"),
      dataIndex: "sale_name",
      key: "sale_name",
    },
    {
      title: tSales("Table_Sales.Company_Name"),
      dataIndex: "company_id",
      key: "company_id",
      render: (_, record) => {
        const value = record.app_company;
        const company = value ? value.company_name + "(" + value.company_code + ")" : "-";
        return <p>{company}</p>;
      },
    },
    {
      title: tSales("Table_Sales.Customer_Count"),
      dataIndex: "customer_count",
      key: "customer_count",
      render: (_, record) => {
        const value = record.customer_count;
        return <p>{value ? value : "0"}</p>;
      },
    },
    {
      title: tSales("Table_Sales.Email_Address"),
      dataIndex: "email",
      key: "email",
    },
    {
      title: tSales("Table_Sales.Telephone"),
      dataIndex: "telephone",
      key: "telephone",
    },
    {
      title: tSales("Table_Sales.Note"),
      dataIndex: "note",
      key: "note",
    },
    {
      title: tSales("Table_Sales.Created_At"),
      dataIndex: "created_at",
      key: "created_at",
      render: (_, record) => {
        const created_at = record.created_at != null ? dayjs(record.created_at).format("YYYY-MM-DD hh:mm:ss A") : "-";
        return <p>{created_at}</p>;
      },
    },
    {
      title: t("Company_Table.Table_Edit"),
      dataIndex: "edit",
      key: "edit",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.Sale?.CHANGE)}
          onClick={() => {
            promiseAwait = new Promise((resolve) => {
              showModal();
              setIsEditSale(true);
              resolve(setEditCompanySalesData(record));
            });
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: t("Company_Table.Table_Delete"),
      dataIndex: "delete",
      key: "delete",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.Sale?.DELETE)}
          onClick={() => {
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  const onFinish = async () => {
    const values = await form.getFieldValue();
    const itemValues = {
      sale_code: values?.search,
      sale_name: values?.search,
      created_at_start: dateRange?.[0],
      created_at_end: dateRange?.[1],
    };

    if (values?.company_id !== "All") {
      itemValues.company_id = values.company_id;
    }

    setTempSearch(itemValues);

    await onSearch(itemValues);
  };

  const onSearch = async (values = {}) => {
    const param = {
      sale_code: values?.sale_code,
      sale_name: values?.sale_name,
      sale_id: "ALL",
      created_at_start: values?.created_at_start,
      created_at_end: values?.created_at_end,
      company_id: values.company_id,
    };
    if (!hasGroup(AuthGroup.CompanyOwner) && !isSuperuser) {
      param.sale_id = saleId;
    }
    try {
      await fetchSales({ ...param, page: values.page || initPage.page, limit: values.limit || initPage.limit });
    } catch (err) {
      console.error("[SalesPage] onSearch: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
    }
  };

  const fetchSales = useCallback(
    async (param) => {
      setLoading(true);
      try {
        const response = await saleService.getSales(accessToken, param);
        if (response) {
          setTotal(response.totalCount);
          setDataList(response.data);
          setSearch({ ...param });
        }
      } catch (err) {
        console.error("[SalesPage] fetchSales: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  const fetchCustomerCompany = useCallback(
    async (companyId) => {
      try {
        let data = [];

        if (isSuperuser) {
          data = await companyManagementService.getCompanysList(accessToken);
        } else if (companyId) {
          const customerData = await companyManagementService.getCompanyById(accessToken, companyId);
          data.push(customerData);
          setIsDisableSelectCompany(true);
        }
        setCompanyList(data);
      } catch (err) {
        console.error("[SalesPage] fetchCustomerCompany: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      }
    },
    [accessToken]
  );

  const optionCompanySelection = (companies = []) => {
    const hasMultiple = companies.length > 1;

    return [
      ...(hasMultiple ? [{ label: "All Company", value: "all" }] : []),
      ...companies.map((item, index) => ({
        label: `${item.company_name} (${item.company_code})`,
        value: item.id,
        key: `company-${index}-${item.id}`,
      })),
    ];
  };

  const handleDateChange = (_, dateStrings) => {
    setDateRange(dateStrings);
  };

  const disableFutureDates = (current) => {
    return current && current.isAfter(dayjs().endOf("day"));
  };

  const handleCancel = () => {
    setIsOpenModal(false);
  };

  const showModal = () => {
    setIsOpenModal(true);
  };

  const exportExcel = async () => {
    setLoading(true);
    const params = { page: 1, limit: total };
    try {
      const request = {
        ids: selectRowKey.length ? JSON.stringify(selectRowKey) : [],
        ...params,
      };

      const response = await saleService.exportExcel(accessToken, request);

      const contentDisposition = response.headers["content-disposition"];
      let filename = `sales-${dayjs().format("YYYY-MM-DD")}`; // Fallback filename
      if (contentDisposition) {
        const matches = contentDisposition.match(/filename="([^"]+)"/);
        if (matches && matches[1]) {
          filename = matches[1];
        }
      }

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      // Create a link for downloading
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename; // Set the filename
      document.body.appendChild(link);
      link.click(); // Trigger download
      document.body.removeChild(link); // Cleanup

      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Export Excel Success"}</>);
    } catch (err) {
      console.error("[SalesPage] exportExcel: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
    } finally {
      setLoading(false);
    }
  };

  const onDeleteCompanySale = async (data) => {
    let prepareDeleteCompanySale = {
      id: data.id,
    };

    setLoading(true);
    try {
      const response = await companyManagementService.deleteCompanySale(accessToken, prepareDeleteCompanySale);
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      onSearch({});
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[SalesPage] onDeleteCompanySale: ", err);
    } finally {
      setLoading(false);
    }
  };

  const onReset = async () => {
    form.resetFields();
    try {
      setLoading(true);
      setCountSelect(0);
      await fetchSales({ ...initPage });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!accessToken) return;
    const initLoad = async () => {
      setLoading(true);
      try {
        await Promise.all([onSearch({ ...search }), fetchCustomerCompany(companyId)]);
      } finally {
        setLoading(false);
      }
    };
    initLoad();
  }, [accessToken]);

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row>
          <Col span={24}>
            <Breadcrumb items={items} />
            <Title
              level={4}
              style={{
                textWrap: "nowrap",
                display: "flex",
                gap: "7px",
                padding: "15px 0px",
              }}
            >
              <ArrowLeftOutlined style={{ fontSize: "20px" }} />
              {t("Sale.Title_Sale")}
            </Title>
          </Col>
        </Row>
        {/* form */}
        <Row style={{ display: "flex", justifyContent: "left", overflowX: "auto" }}>
          <Col span={12}>
            <Form
              form={form}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              labelAlign="left"
              layout="horizontal"
              onFinish={onFinish}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  form.submit();
                }
              }}
              initialValues={{
                search: undefined,
                company_id: companyId ? companyId : "all",
                created_at: [dayjs().startOf("day"), dayjs().endOf("day")],
              }}
            >
              <Row flex={1}>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Row>
                    <Col span={24}>
                      <Form.Item label={tSales("Search_Form.Search")} name="search" key="search">
                        <Input placeholder="Sale Code/ Sale Name" style={{ minWidth: 200 }} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item name="created_at" label={tSales("Search_Form.Create_At")}>
                    <RangePicker
                      allowEmpty
                      style={{ width: "100%", minWidth: 200 }}
                      onChange={handleDateChange}
                      disabledDate={disableFutureDates}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={{ minWidth: 280 }}>
                  <Form.Item label={tSales("Search_Form.Company")} name="company_id" key="company_id">
                    <Select
                      style={{ width: "100%", minWidth: 200 }}
                      disabled={isDisableSelectCompany}
                      showSearch
                      optionFilterProp="label"
                      options={optionCompanySelection(companyList)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify="end" align="middle">
                <Col span={24} style={{ textAlign: "end" }}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      {t("Sale.Search")}
                    </Button>
                    <Button type="default" onClick={() => onReset()} style={{ marginLeft: "5px" }}>
                      {t("BTN_Reset", { ns: "buttons" })}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        {/* button with permission */}
        <Row align="middle" justify={"center"}>
          <Col span={24} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Space direction="inline">
              {/* {hasPermission(Permissions.Sale?.ADD) && <Button type="primary">{"Export to Excel"}</Button>} */}
              {/* {hasPermission(Permissions.Sale?.ADD) && (
                <Button type="primary" onClick={showModal}>
                  {"Add Sales"}
                </Button>
              )} */}
              {hasPermission(permissions.Sale?.EXPORT) && (
                <Button type="primary" onClick={exportExcel}>
                  {t("BTN_Export_Excel", { ns: "buttons" })}
                </Button>
              )}
              {hasPermission(permissions.Sale?.ADD) && (
                <Button type="primary" onClick={showModal}>
                  {t("Sale.Add_Sale")}
                </Button>
              )}
            </Space>
          </Col>
        </Row>
        {/* Table */}
        <Row align="middle" justify="center">
          <Col span={24}>
            <Card>
              {`select: ${countSelect} to ${total}`}&nbsp;
              <Link onClick={onSelectAll} target="_blank">
                {`select all`}
              </Link>
              <Table
                loading={loading}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={dataList}
                scroll={{ x: "max-content" }}
                rowKey={(record) => record.id}
                style={{ cursor: "pointer" }}
                pagination={{
                  defaultPageSize: search.page,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  current: search.page,
                  pageSize: search.limit,
                  total: total,
                  onChange: (page, limit) => {
                    onSearch({ ...tempSearch, page, limit });
                  },
                  showSizeChanger: true,
                }}
              />
            </Card>
          </Col>
          <ModelCreateSales
            isModalOpen={isModelOpen}
            setIsModalOpen={setIsOpenModal}
            handleOk={handleCancel}
            handleCancel={handleCancel}
            editCompanySalesData={editCompanySalesData}
            fetchCompanySales={onSearch}
            isEditSale={isEditSale}
            t={t}
            isDisableSelectCompany={isDisableSelectCompany}
            optionCompany={optionCompanySelection(companyList)}
            optionDefaultCompany={
              companyId ?? (companyList.length === 1 ? companyList[0]?.id : "all")
            }
          />
        </Row>
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            onDeleteCompanySale(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
